<template>
  <div class="conversation-sidebar-wrap lia-sidebar-wrap">
    <div class="lia-sidebar--header">
      <img
        class="lia-sidebar--avatar"
        src="~dashboard/assets/images/lia-avatar.png"
        :alt="$t('INTEGRATION_SETTINGS.OPEN_AI.LIA.AVATAR_ALT')"
      />
      <h3 class="sub-block-title lia-sidebar--title">
        {{ $t('INTEGRATION_SETTINGS.OPEN_AI.LIA.SIDEBAR_TITLE') }}
      </h3>
      <woot-button
        icon="dismiss"
        class="close-button--rtl"
        type="button"
        data-test-id="lia-sidebar-close"
        @click="$emit('toggle-lia-sidebar')"
      />
    </div>
    <dashboard-app-frame
      :key="currentChat.id"
      class="lia-sidebar--frame"
      :is-visible="true"
      :config="copilotFrameConfig"
      :current-chat="currentChat"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DashboardAppFrame from 'dashboard/components/widgets/DashboardApp/Frame';
import liaCopilotMixin from 'dashboard/mixins/liaCopilotMixin';

export default {
  components: {
    DashboardAppFrame,
  },
  mixins: [liaCopilotMixin],
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
    }),
  },
};
</script>

<style lang="scss" scoped>
.conversation-sidebar-wrap.lia-sidebar-wrap {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.lia-sidebar--header {
  position: relative;
  background-color: #053ca8;
  min-height: var(--space-larger);
  display: flex;
  align-items: center;
  gap: var(--space-slab);
  padding: var(--space-small) var(--space-large) var(--space-small)
    var(--space-medium);

  .lia-sidebar--avatar {
    width: 3.6rem;
    height: 3.6rem;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .lia-sidebar--title {
    color: var(--b-50);
    margin: 0;
    overflow-wrap: break-word;
  }

  .close-button--rtl {
    position: absolute;
    top: var(--space-small);
    right: var(--space-small);
    width: auto;
    height: auto;
    background: transparent;

    &:hover {
      background-color: transparent;
      color: var(--white-transparent);
    }
  }
}

.lia-sidebar--frame {
  flex: 1;
  min-height: 0;
  height: auto;

  ::v-deep iframe {
    display: block;
  }
}
</style>
